<script setup lang="ts">
import { computed, toRef } from "vue";
import { Input } from "@/components/ui/input";
import OptionRow from "./OptionRow.vue";
import OptionSection from "./OptionSection.vue";
import { useCardLocalOptions } from "@/composables/useCardLocalOptions";

const props = defineProps({
  card: { type: Object, required: true },
  defaultName: { type: String, default: "" },
  defaultTitle: { type: String, default: "" },
  description: { type: Boolean, default: false },
});

const cardRef = toRef(props, "card");
const { localOptions, updateLocalOption } = useCardLocalOptions(cardRef);

const secondLabel = computed(() => (props.description ? "Description" : "Title"));

function setCustomNameTitle(patch: { name?: string; title?: string }) {
  const next = { ...localOptions.value.custom_name_title, ...patch };
  updateLocalOption("custom_name_title", next.name || next.title ? next : null);
}

const customName = computed({
  get: () => localOptions.value.custom_name_title?.name || "",
  set: (val: string) => setCustomNameTitle({ name: val }),
});

const customTitle = computed({
  get: () => localOptions.value.custom_name_title?.title || "",
  set: (val: string) => setCustomNameTitle({ title: val }),
});

const count = computed(() => [customName.value, customTitle.value].filter(Boolean).length);
</script>

<template>
  <OptionSection
    id="labels"
    :title="`Name & ${secondLabel.toLowerCase()}`"
    :count="count">
    <OptionRow label="Name">
      <Input
        :model-value="customName"
        :placeholder="defaultName || 'Name'"
        @update:model-value="customName = $event" />
    </OptionRow>
    <OptionRow :label="secondLabel">
      <Input
        :model-value="customTitle"
        :placeholder="defaultTitle || (description ? 'Optional description' : 'Title')"
        @update:model-value="customTitle = $event" />
    </OptionRow>
  </OptionSection>
</template>
